import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import DataTable from 'react-data-table-component';
import Swal from "sweetalert2";
import { Pencil, Trash2, X, File, List,FileX, Calendar,Funnel,Printer, Upload,TicketCheck } from 'lucide-react';

import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import DateRangePicker from "../components/DateRangePicker"; 
import NProgress from "nprogress";
import 'nprogress/nprogress.css';

const Rf = () => {

  
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const NProgressSpinner = () => (
    <div style={{ padding: "1rem", textAlign: "center" }}>
      <div
        style={{
          boxSizing: "border-box",
          display: "block",
          width: "40px",
          height: "40px",
          border: "4px solid #29d",
          borderRadius: "50%",
          borderTopColor: "transparent",
          animation: "spin 0.6s linear infinite",
          margin: "0 auto 10px"
        }}
      ></div>
      <div>Memuat data, sabar yaa...</div>
    </div>
  );
    
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const email = storedUser?.email;
  const level = storedUser?.level;
  
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const email = storedUser?.email;

    fetch(`${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setUser(data.data);
          console.error(data.data);
        } else {
          console.error(data.message);
        }
      })
      .catch((err) => console.error(err));
  }, []);


  const [data, setData] = useState([]);
  const [pending, setPending] = useState(false);
  const [editEvent, setEditEvent] = useState(null);
  const [formData, setFormData] = useState({ name: '', client: '' , status: '',group_id:'' });
  const [searchText, setSearchText] = useState('');
  const [ShowModalFilterAjuan, setShowModalFilterAjuan] = useState(false);
  const [ShowModalAdvanceFilter, setShowModalAdvanceFilter] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showFilterTanggalExcel, setShowFilterTanggalExcel] = useState(false);
  const [showUploadTrf, setShowUploadTrf] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleFilterAjuan = async (e) => {
    const selectedValue = e.target.value;
    setFormData({ ...formData, group_id: selectedValue });

    let endpoint = '';
    let textNotif = '';
      switch (selectedValue) {
        case '1':
          endpoint = 'printed';
          textNotif = 'Sudah Print';
          break;
        case '2':
          endpoint = 'unprinted';
          textNotif = 'Belum Print';
          break;
        case '3':
          endpoint = 'transfered';
          textNotif = 'Sudah Transfer';
          break;
        case '4':
          endpoint = 'untransfered';
          textNotif = 'Belum Transfer';
          break;
        case '6':
          endpoint = 'um';
          textNotif = 'Uang Muka';
          break;
        case '7':
          endpoint = 'reimbursement';
          textNotif = 'Reimburse';
          break;
        case '8':
          endpoint = 'dp';
          textNotif = 'DP ke Vendor/Talent';
          break;
        case '9':
          endpoint = 'pelunasan';
          textNotif = 'Pelunasan ke Vendor/Talent';
          break;
        case '5':
          endpoint = 'all';
          break;
        default:
          endpoint = 'all';
      }

    if (endpoint !== '') {
        fetchFilteredData(endpoint); 
        setSuccess(`Menampilkan Ajuan ${textNotif}`);
        setTimeout(() => setSuccess(false), 30000);
    }
    setShowModalFilterAjuan(false)
  };

  useEffect(() => {
    fetchFilteredData('all');
  }, []);

  // const fetchData = () => {
  //   fetch('http://localhost:8080/api/rf')
  //     .then((res) => res.json())
  //     .then((result) => {
  //       setData(result.data);
  //       setPending(false);
  //     });
  // };

  const [filters, setFilters] = useState({
    printed: false,
    unprinted: false,
    transfered: false,
    untransfered: false,
    um: false,
    dp: false,
    pelunasan: false,
    reimburse: false,
    all: false
  });

  const [textNotif, setTextNotif] = useState(null);
  const [notif, setNotif] = useState();
  const [loading, setLoading] = useState(false);

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;

    // jika pilih "all", reset filter lain
    if (name === "all") {
      setFilters({
        printed: false,
        unprinted: false,
        transfered: false,
        untransfered: false,
        um: false,
        dp: false,
        pelunasan: false,
        reimburse: false,
        all: checked
      });
    } else {
      setFilters({
        ...filters,
        [name]: checked,
        all: false // uncheck all jika pilih lainnya
      });
    }
  };

  const notifMap = {
    printed: "Sudah Print",
    unprinted: "Belum Print",
    transfered: "Sudah Transfer",
    untransfered: "Belum Transfer",
    um: "Uang Muka",
    dp: "DP ke Vendor/Talent",
    pelunasan: "Pelunasan ke Vendor/Talent",
    reimburse: "Reimburse",
    all: "Semua Ajuan"
  };

  const applyFilters = async () => {
    setLoading(true);
    try {
      const selected = Object.keys(filters).filter(f => filters[f]);
      const query = selected.join(",");

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/advanceFilter?filters=${query}`);
      const result = await res.json();
      setData(result.data || []);
      setShowModalAdvanceFilter(false);
      setSuccess(`Menampilkan Ajuan ${selected.length ? selected.map(f => notifMap[f]).join(", ") : "Semua Ajuan"}`);
    } catch (err) {
      setData([]);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchFilteredData = async (filterType) => {
    setPending(true); // jika kamu pakai loading state
    NProgress.start();
    let textNotif = '';

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/filter/${filterType}`); 
      switch (filterType.toLowerCase()) {
        case 'printed':
          textNotif = 'Sudah Print';
          break;
        case 'unprinted':
          textNotif = 'Belum Print';
          break;
        case 'transfered':
          textNotif = 'Sudah Transfer';
          break;
        case 'untransfered':
          textNotif = 'Belum Transfer';
          break;
        case 'um':
          textNotif = 'Uang Muka';
          break;
        case 'reimburse':
          textNotif = 'Reimburse';
          break;
        case 'dp':
          textNotif = 'DP ke Vendor/Talent';
          break;
        case 'pelunasan':
          textNotif = 'Pelunasan ke Vendor/Talent';
          break;
        case 'all':
          textNotif = 'Semua Ajuan';
          break;
        default:
          textNotif = 'Semua Ajuan';
      }     

      const result = await response.json();

      if (Array.isArray(result.data)) {
        setData(result.data); // asumsi kamu punya state setDat
      } else {
        setData([]);
      }
      } catch (error) {
        setData([]);
      } finally {
        setPending(false);
        NProgress.done(); // selesai loading
      }
    };

  const filteredData = data.filter((item) => {
    const combined = [
      item.event,
      item.vendor,
      item.note,
      item.pic ?? "",
      item.input_date,
    ].join(" ").toLowerCase();

    const searchWords = searchText.toLowerCase().split(" ").filter(Boolean);

    const matchSearch = searchWords.every((word) => combined.includes(word));

    // tambahan filter berdasarkan level / email
    if (user.level === "event") {
      return matchSearch && item.user_input === user.email;
    }

    if (user.level === "admin") {
      // admin bisa lihat semua, hanya filter search
      return matchSearch;
    }

    // default
    return matchSearch;

  });

  const handleEdit = (id) => {
    navigate(`/updateRf/${id}`);
  };

  const handleDelete = async (id) => {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`);
    const result = await res.json();
    const note = result.data?.note || "User tidak diketahui";
    
    Swal.fire({
      title: `Yakin hapus ini?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire({
              toast: true,
              position: 'top',
              icon: 'warning',
              title: 'Terhapus',
              text: `Ajuan berhasil dihapus`,
              showConfirmButton: false,
              showCloseButton: true, 
            });
            fetchFilteredData('all');
          });
      }
    });
  };

  

  const handleTrf = async (id) => {
    // Ambil data dulu
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`);
    const result = await res.json();
    const note = result.data?.note || result.data?.notes || "Ajuan tidak diketahui";
    const trfValue = parseInt(result.data?.trf ?? 0);
    const trfStatus = trfValue === 1 ? 0 : 1; 

    Swal.fire({
      title: `Ubah Status Transfer?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3c30e9ff',
      cancelButtonColor: '#e9303fff',
      confirmButtonText: 'Ya, sudah',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        const today = new Date().toISOString().split("T")[0]; 
        fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ trf: trfStatus,read:"read", trf_by:email, date_of_trf:today  }),
        })
          .then((res) => res.json())
          .then(() => {
            setSuccess(`Ajuan ${note} sudah dirubah status transfernya`);
            setTimeout(() => setSuccess(false), 30000);
            fetchFilteredData('all');
          });
      }
    });
  };

  const [isOpen, setIsOpen] = useState(false);

  const [imageUrl, setImageUrl] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [file, setFile] = useState(null);

  const handleBuktiTrf = async (id) => {
    // Buka modal dulu supaya tidak delay
    setIsOpen(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/trfimage/${id}`);
      const result = await res.json();
      setFileData(result.data);
    } catch (err) {
      console.error("Gagal ambil gambar:", err);
    }
  };

  const handleUpload = (id) => {
    setSelectedId(id); // simpan ID
    setShowUploadTrf({ name: id.name, id_rf : id }); // tampilkan modal
  };
  const [formTrfImage, setFormTrfImage] = useState(null);

  const [statusRead, setStatusRead] = useState({ trf: '1'});
  
  const [selectedId, setSelectedId] = useState(null);

  const handleUploadTrfImage = async (e) => {
    e.preventDefault();

    // Cek kalau belum pilih file
    if (!file) {
      alert("Silakan pilih file terlebih dahulu.");
      return;
    }
    // Siapkan FormData
    const formData = new FormData();
    formData.append("file", file);       
    formData.append("id", selectedId);     
    formData.append("upload_by", email);   

    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/trfimage/savefile`, {
        method: "POST",
        body: formData, // penting: FormData langsung, tanpa headers 'Content-Type'
      });

      const result = await res.json();

      if (res.ok && result.status === "success") {
        fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${selectedId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(statusRead),
        })
        Swal.fire('Terupload!', 'Bukti trf berhasil terupload', 'success');
        setShowUploadTrf(false); // Tutup modal
        setFile(null);           // Reset file
      } else {
        alert(result.message || "Gagal upload file");
      }
    } catch (error) {
      console.error("Error upload:", error);
      alert("Terjadi kesalahan saat upload");
    }
  };


  const fileUrl = fileData?.name ?`${process.env.REACT_APP_BASE_URL}/uploads/${fileData.name}` : null;

  const isPDF = fileData?.name?.toLowerCase().endsWith(".pdf");

  const [uploadTrfImage, setUploadTrfImage] = useState(null); 

  
  const columns = [
    
    {
      name: 'Tanggal',
      selector: row => new Date(row.tanggal_final),
      sortable: true,
      cell: row => {
        const date = format(new Date(row.tanggal_final), "dd MMM yyyy");
        const time = format(new Date(row.tanggal_final), "H:mm");
        return (
          <div>
            {date}
            <br />
            {time}
          </div>
        );
      },
      grow: 2,
    },
    {
      name: 'Keterangan',
      selector: row => row.note,
      sortable: true,
      wrap: true,
      width: "27%",
    },
    {
      name: 'Vendor',
      selector: row => row.vendor,
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: 'Event',
      selector: row => row.event,
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: 'PIC',
      selector: row => row.pic,
      sortable: true,
      wrap: true,
      width: "10%",
    },
    {
      name: 'Status',
      cell: (row)=>(
        <div>
          <span
            className={`px-2 py-1 rounded-full ${
              row.trf == 1
                ? 'bg-green-100 text-green-700'
                : row.read === "read"
                  ? 'bg-purple-100 text-purple-700'
                  : 'bg-red-100 text-red-700'
            }`}
          >
            {
              row.trf == 1
                ? 'Sudah Transfer'
                : row.read === "read"
                  ? 'Sudah Print'
                  : 'Belum Print'
            }
          </span>
        </div>
      ),
      grow: 2,
    },
    {
      name: 'Total',
      cell: (row) => (
        <span
          className={`px-2 py-1 font-semibold rounded-full ${
            row.trf === "1"
              ? 'bg-green-100 text-green-700'
              : 'bg-red-100 text-red-700'
          }`}
        >
          {new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
          }).format(row.total)}
        </span>
      ),
      ignoreRowClick: true,
      grow: 2,
    },
  ];

  if (["1"].includes(user?.group_id ?? "")){
    columns.push({
      name: 'Aksi',
      cell: (row) => (
        <div className="flex gap-1">
          <button
            className="bg-yellow-300 hover:bg-yellow-500 text-white p-1 rounded"
            onClick={() => handleEdit(row.id)}
          >
            <Pencil size={14} />
          </button>
          <button
            className={`${
              row.trf == 0
                ? 'bg-green-400 hover:bg-green-600'
                : 'bg-purple-400 hover:bg-purple-600'
            } text-white p-1 rounded`}
            onClick={() => handleTrf(row.id)}
          >
            <TicketCheck size={14} />
          </button>          
          <button
            className="bg-red-400 hover:bg-red-600 text-white p-1 rounded"
            onClick={() => handleDelete(row.id)}
          >
            <Trash2 size={14} />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: "10%"
    });
  }
  
  if (["2"].includes(user?.group_id ?? "")){
    columns.push({
      name: 'Aksi',
      cell: (row) => (
        <div className="flex gap-1">        
          <button
            className="bg-yellow-300 hover:bg-yellow-500 text-white p-1 rounded"
            onClick={() => handleEdit(row.id)}
          >
            <Pencil size={14} />
          </button>
          <button
            className={`${
              row.trf == 0
                ? 'bg-green-400 hover:bg-green-600'
                : 'bg-purple-400 hover:bg-purple-600'
            } text-white p-1 rounded`}
            onClick={() => handleTrf(row.id)}
          >
            <TicketCheck size={14} />
          </button>  
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: "10%"
    });
  }

  const customStyles = {
    table: {
      style: {
        // borderRadius: '15px', //rounded nya
        // border: '1px solid #ccc',
        overflow: 'hidden',  
      },
    },
    headRow: {
      style: {
        fontWeight: 'bold',
        borderRight: '0.5px solid #ccc',  
        color: '#111827', 
        fontSize: '18px',
      },
    },
    headCells: {
      style: {
        borderLeft: '0.5px solid #ccc', 
        padding: '8px'
      },
    },
    rows: {
      style: {
        // border: '1px solid #ccc',
        borderRight: '0.5px solid #ccc',   
        fontSize: '16px',
        
      },
      stripedStyle: {
        backgroundColor: "#f2f2f2", // warna abu tua untuk row striped
      },
    },
    cells: {
      style: {
        // border: '0.5px solid #ccc',
        borderLeft: '0.5px solid #ccc',   
        padding: '8px'
      },
    },
  };

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSubmitExport = (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      alert("Pilih tanggal terlebih dahulu!");
      return;
    }
    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    if (!user.email || !user.level) {
        console.error("User tidak ditemukan di localStorage");
        return;
      }

    if (user.level === "admin" || user.level === "finance") {
      window.location.href = `${process.env.REACT_APP_BASE_URL}export/filteredRf?start=${formattedStart}&end=${formattedEnd}`;
    } else {
      window.location.href = `${process.env.REACT_APP_BASE_URL}export/export?start=${formattedStart}&end=${formattedEnd}&user_input=${encodeURIComponent(user.email)}`;
    }
  };


  return (
    <div className="flex bg-white p-5 rounded-lg shadow-lg w-full">
      <div className="p-4 w-full overflow-y-auto">
        {success && (
            <div className="mt-2 mb-4 bg-green-100 text-green-800 p-4 rounded shadow transition-all duration-30000 flex justify-between">
              <div className="">
                <h1 className="text-md font-bold"> Berhasil</h1>
                {success}
              </div>
              <button
                onClick={() => setSuccess(null)}
                className="ml-auto text-green-600 hover:text-green-800 transition"
              >
                <X size={16} />
              </button>
            </div>
          )}
        <div className="flex justify-between bg-gray-600 flex-wrap gap-2 p-4 mb-2 rounded">
          <div className="flex flex-col sm:flex-row gap-2">            
            {(["1", "3", "2"].includes(user?.group_id ?? "")) && (
              <Link
                to="/create"
                className="flex items-center gap-2 bg-white hover:bg-white/50 text-black px-2 py-2 rounded text-md"
              >
                <File size={16} />
                Buat Form Ajuan
              </Link>
            )}
            {/* <button type="button"
              onClick={() => setShowModalFilterAjuan(true)}  className="flex items-center bg-blue-600 hover:bg-blue-700 text-white gap-2 px-2 py-2 rounded shadow text-md">
              <Funnel size={16} /> Filter Ajuan
            </button> */}
            <button type="button"
              onClick={() => setShowModalAdvanceFilter(true)}  className="flex items-center bg-blue-500 hover:bg-blue-400 text-white gap-2 px-2 py-2 rounded shadow text-md">
              <Funnel size={16} /> Advance Filter
            </button>
            <button type="button"
              onClick={() => setShowModal(true)} className="flex items-center border border-rose-700 bg-rose-500 hover:bg-rose-400 text-white px-2 py-2 gap-2 rounded shadow text-md">
              <Calendar size={16} /> Filter Tanggal
            </button>
            {(["1", "2", "3"].includes(user?.group_id ?? "")) && (
              <button type="button"
                onClick={() => setShowFilterTanggalExcel(true)} className="flex items-center border border-green-300 bg-green-500 hover:bg-green-700 text-green-700 px-2 py-2 gap-2 rounded shadow text-md text-white ">
                <FileX size={16} /> Export ke Excel
              </button>
            )}
          </div>
          <div className="flex gap-2">
            <input
              type="text"
              placeholder="Pencarian..."
              className="border border-gray-300 text-md px-2 py-2 rounded "
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>
        <DataTable
        columns={columns}
        data={filteredData}
        pagination
        responsive
        striped
        progressPending={pending}       
        progressComponent={<NProgressSpinner  />}
        highlightOnHover
        fixedHeader
        customStyles={customStyles}
        conditionalRowStyles={[
          {
            when: row => row.read === "unread",
            style: {
              fontWeight: "bold"
            },
          }]}
        onRowClicked={row => {
          const url = `/v2/detail/${row.id}`;
          window.open(url, "_blank");
        }}
        />
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <form className="space-y-4">
            <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
              <h3 className="text-lg font-bold mb-4">Filter Tanggal</h3>

              {/* Komponen DateRange */}
              <DateRangePicker
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
              />

              <div className="flex justify-end gap-2 mt-6">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                >
                  Batal
                </button>
                <button
                  onClick={() => {
                    const start = startDate ? format(startDate, "yyyy-MM-dd") : "";
                    const end = endDate ? format(endDate, "yyyy-MM-dd") : "";
                    setShowModal(false);
                    navigate(`/filteredRf?start=${start}&end=${end}`);
                    setShowModal(false);                    
                  }}
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                >
                  Terapkan
                </button>
              </div>
            </div>
            </form>
        </div>
      )}
      {showFilterTanggalExcel && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <form className="space-y-4">
            <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
              <h3 className="text-lg font-bold mb-4">Filter Tanggal Export ke Excel</h3>
              {/* Komponen DateRange */}
              <DateRangePicker
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
              />

              <div className="flex justify-end gap-2 mt-6">
                <button
                  onClick={() => setShowFilterTanggalExcel(false)}
                  className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                >
                  Batal
                </button>
                <button
                  onClick={handleSubmitExport}
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                >
                  Terapkan
                </button>
              </div>
            </div>
            </form>
        </div>
      )}
      {ShowModalFilterAjuan && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <form className="space-y-4">
            <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
              <h3 className="text-lg font-bold mb-4">Filter berdasarkan</h3>

              <select
                  id="pilihan"
                  value={formData.group_id}
                onChange={handleFilterAjuan}
                className="block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:border-blue-500"
              >
                <option value="">-- Pilih --</option>
                <option value="1">Sudah Print</option>
                <option value="2">Belum Print</option>
                <option value="3">Sudah Transfer</option>
                <option value="4">Belum Transfer</option>
                <option value="6">Permintaan Uang Muka</option>
                <option value="7">Reimbursement</option>
                <option value="8">DP ke Vendor/Talent</option>
                <option value="9">Pelunasan ke Vendor/Talent</option>
                <option value="5">Tampilkan Semua</option>
              </select>

              <div className="flex justify-end gap-2 mt-6">
                <button
                  onClick={() => setShowModalFilterAjuan(false)}
                  className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                >
                  Batal
                </button>
                
              </div>
            </div>
            </form>
        </div>
      )}

      {ShowModalAdvanceFilter && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <form className="space-y-4">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full">
              <h3 className="text-lg font-bold mb-4">Filter berdasarkan</h3>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 mb-4">
                {Object.keys(filters).map((f) => (
                  <label key={f} className="flex items-center space-x-2 bg-gray-100 p-2 rounded hover:bg-gray-200 cursor-pointer">
                    <input
                      type="checkbox"
                      name={f}
                      checked={filters[f]}
                      onChange={handleCheckbox}
                      className="form-checkbox h-5 w-5 text-blue-600"
                    />
                    <span className="capitalize">{notifMap[f]}</span>
                  </label>
                ))}
              </div>


              <div className="flex justify-end gap-2 mt-6">
                <button
                  onClick={applyFilters}
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Apply Filters"}
                </button>
                <button
                  onClick={() => setShowModalAdvanceFilter(false)}
                  className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                >
                  Batal
                </button>
                
              </div>
            </div>
            </form>
        </div>
      )}

      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg p-4 max-w-3xl w-full relative">
            <button
              className="absolute top-2 right-2 text-gray-500"
              onClick={() => {
                setIsOpen(false);
                setFileData(null);
              }}
            >
              ✕
            </button>

            <h2 className="text-lg font-bold mb-4">File Bukti Transfer</h2>

            {!fileData ? (
              <p className="text-gray-500">File tidak ditemukan</p>
            ): fileData.data === null ? (
              <p className="text-red-500">File tidak ditemukan</p>
            ) : isPDF ? (
              <iframe
                src={fileUrl}
                className="w-full h-[500px]"
                title="PDF Viewer"
              />
            ) : (
              <img src={fileUrl} alt="Preview" className="w-full rounded" />
            )}
          </div>
        </div>
      )}

      {showUploadTrf && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg p-4 max-w-3xl w-full relative">
            <button
              className="absolute top-2 right-2 text-gray-500"
              onClick={() => {
                setShowUploadTrf(false);
              }}
            >
              ✕
            </button>

            <h2 className="text-lg font-bold mb-4">Upload Bukti Transfer </h2>
            <form onSubmit={handleUploadTrfImage} className="space-y-4">
              <div>
                <label className="block font-medium">File</label>
                <input
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  className="w-full border p-2 rounded"
                />
                <input
                  type="hidden"
                  value={selectedId}
                  className="border p-2 w-full mb-4"
                  readOnly // jika mau hanya bisa dibaca
                />
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-300 rounded"
                  onClick={() => setShowUploadTrf(false)}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-black/100 text-white rounded hover:bg-black/70"
                >
                  Simpan
                </button>
              </div>
            </form> 
            
          </div>
        </div>
      )}
    </div>    
  );
};

export default Rf;
